import { render, staticRenderFns } from "./AssociarNotificacaoApple.vue?vue&type=template&id=433d957c"
import script from "./AssociarNotificacaoApple.vue?vue&type=script&lang=ts"
export * from "./AssociarNotificacaoApple.vue?vue&type=script&lang=ts"
import style0 from "./AssociarNotificacaoApple.vue?vue&type=style&index=0&id=433d957c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports